import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import { loadStripe } from "@stripe/stripe-js";
import {
  Elements,
  CardElement,
  useStripe,
  useElements,
} from "@stripe/react-stripe-js";
import Image from "../../assets/image/brown.png";
import { useAuth } from "../../context/AuthContext";
import { saveCard } from "../../services/cardsFn";
import AppLoader from "../loader/loader";
import { useNavigate } from "react-router-dom";

const stripePromise = loadStripe(
  "pk_test_51RFH6KIo5BKtfomBMPodlqErPpTkWi6K6O0YTCsl9m4uR33o2t3aFPLYBT80XR7K3QpFCjg4dGEW99wcPxRMVOgZ00cjmXldPx"
);

const CreateCard = () => {
  const stripe = useStripe();
  const elements = useElements();
  const [message, setMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const { userId } = useAuth();
  const navigate = useNavigate();

  const handleSaveCards = async (payload) => {
    try {
      setIsLoading(true);
      const response = await saveCard(payload);
      if (response.data.status === "success") {
        setMessage("Card saved successfully!");
        navigate("/payment");
      } else {
        setMessage(response?.data.message || "Error saving card");
      }
      console.log("API Response:", response);
    } catch (error) {
      console.error("Error saving card:", error);
      setMessage("Error saving card: " + error.message);
    } finally {
      setIsLoading(false);
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!stripe || !elements) {
      setMessage("Stripe has not loaded yet.");
      return;
    }

    const cardElement = elements.getElement(CardElement);

    try {
      setIsLoading(true);
      const { token, error } = await stripe.createToken(cardElement, {
        // name: email,
      });

      if (error) {
        console.error(error);
        setMessage(error.message);
      } else {
        console.log("Payment Method:", token);
        const payload = {
          userId: userId?._id,
          email: userId?.email,
          paymentId: token.id,
        };

        await handleSaveCards(payload);
      }
    } catch (error) {
      console.error(error);
      setMessage("An error occurred. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <AppLoader isVisible={isLoading} />
      <section className="Stripecard-section">
        <div className="Stripecard-hero">
          <div className="container Stripe-con">
            <div className="box box-div">
              <div className="row d-flex align-items-center justify-content-center">
                <div className="col-lg-1 col-md-2 col-sm-2 col-2 icon-times-col">
                  <div className="icon-times">
                    <FontAwesomeIcon
                      icon={faArrowLeft}
                      className="sub-icon-times"
                      onClick={() => window.history.back()}
                    />
                  </div>
                </div>
                <div className="col-lg-11 col-md-10 col-sm-10 col-10 Create-Card">
                  <h2>Create Card</h2>
                </div>
                {/* <div className="col-lg-2 col-md-2 col-sm-2 col-2 icon-times2-col">
                  <div className="icon-times2">
                    <img src={Image} alt="Stripe Logo" />
                  </div>
                </div> */}
              </div>

              <div className="col-lg-12 col-md-12 col-sm-12 col-12 st-h">
                <h6>Enter your card details</h6>
              </div>

              <form>
                <div className="container-fuild">
                  <div className="row">
                    <div className="col-md-12 form-group">
                      <label htmlFor="card-element" className="input-label">
                        Card Details
                      </label>
                      <CardElement
                        id="card-element"
                        className="input-field"
                        options={{
                          style: {
                            base: {
                              fontSize: "16px",
                              color: "#ffff",
                              "::placeholder": { color: "#ffff" },
                            },
                            invalid: { color: "#fa755a" },
                          },
                        }}
                      />
                    </div>
                  </div>
                  <button
                    type="submit"
                    className="btn-1"
                    onClick={handleSubmit}
                  >
                    Create Card
                  </button>
                </div>
              </form>

              {message && <p className="message">{message}</p>}
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

const AddCard = () => (
  <Elements stripe={stripePromise}>
    <CreateCard />
  </Elements>
);

export default AddCard;
